module.exports = __webpack_public_path__ + "img/player_m.6e0112c9.png";